export default __webpack_public_path__ + "static/media/award.db47a10e.png";